import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { sdiCreditNoteSchema } from "./schema";

export const sdiCreditNoteConfig = defineForm({
  id: "sdi_credit_note",
  createEndpoint: MANUAL_DOC_ENDPOINTS.SDI_CREDIT_NOTE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "CreditNote",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SDI",
  invoiceType: "creditNote",
  complianceType: ComplianceDocumentType.CreditNote,
  requiresLegalRep: true,
  titleKey: "CreditNote",
  complianceStandardKey: "sdi",
  schema: sdiCreditNoteSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  },
  hiddenSections: ["recurring"],
  omitFromPayload: ["customerCompanyAddress"],
});